import { Post as PostComponent } from 'components';
import React from 'react';
import { useLocation, useParams } from 'react-router-dom';

const Post = ({}) => {
  const { postId } = useParams();
  const { pathname } = useLocation();
  const isSharedPost = pathname.startsWith('/shared/post/');

  return (
    <React.Fragment>
      <PostComponent item={{ _id: postId }} fromNavigation isSharedPost={isSharedPost} />
    </React.Fragment>
  );
};

export default Post;
